export default {
  post_search_result:'搜索结果',
  post_conpy_url:'复制链接',
  post_select_circle:'请先选择一个圈子',
  post_uploading_publish:'附件上传中，暂时无法发布内容',
  post_pic_overrun:"上传失败，图片数量超限，请删减后重试",
  post_Success_published:"发布成功",
  post_fileList_limit:'仅支持上传附件个数为{fileList}个',
  post_file_size_limit: '上传单个文件大小不得超过{fileSize}M',
  post_file_type_limit:'仅支持上传PPT、WORD、EXCEL、PDF、图片、压缩包、请重新上传',
  post_Img_size_limit:'图片大小不得大于3M，请重新上传',
  post_Img_upload_seccess:'图片上传成功',
  post_no_circle_tip:'您未选择圈子，暂时@不到对应联系人',
  post_had_click:'您已@该人员',
  post_enter_title:'请输入标题，标题字数在1～20个字之间',
  post_add_circle:'添加圈子',
  post_enter_context:'请输入正文内容，字数限制5000个字',
  post_support_type:'支持上传PPT、WORD、EXCEL、PDF、图片、压缩包格式',
  post_add_enclosure:'添加附件',
  post_publishing:'正在发布',
  post_publish:'发布',
  post_upload_failed:'上传失败，图片数量超限，请删减后重试'
}
